<template>
    <v-container app fluid>
        <v-row>
            <v-col cols="9" class="pt-0 pb-0">
                <v-container class="pt-0" fluid>
                    <v-row>
                        <v-col cols="12" class="pt-0">
                            <v-card>
                                <v-card-text class="pt-0 pb-0">
                                    <v-container fluid>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field
                                                v-model="name_recipe"
                                                label="Nombre de receta"
                                                outlined
                                                hide-details
                                                dense
                                            >
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-card>
                                <v-card-text class="pt-0 pb-0">
                                    <v-container fluid>
                                        <v-row>
                                            <v-col cols="4">
                                                <v-autocomplete
                                                    v-model="category_value"
                                                    :items="categories"
                                                    :item-text="customText"
                                                    clearable
                                                    item-value="id"
                                                    outlined
                                                    dense
                                                    label="Seleccione categoria"
                                                    hide-details
                                                ></v-autocomplete>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-text-field
                                                    v-model="supply_name"
                                                    label="Insumo"
                                                    outlined
                                                    hide-details
                                                    dense                         
                                                >
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-btn dark color="indigo" @click="handleSearchSupply">
                                                    <v-icon dark class="mr-2" size="14">
                                                        fas fa-search
                                                    </v-icon>
                                                    Mostrar insumos
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-card>
                                <v-data-table
                                    :headers="headers"
                                    :items="supplies"
                                    disable-pagination
                                    hide-default-footer
                                    height="48vh"
                                    class="wost-table"
                                >
                                    <template v-slot:item.category_id="{item}">
                                        <span v-if="item.category">{{ item.category.name }}</span>
                                    </template>
                                    <template v-slot:item.unit_id="{item}">
                                        <span v-if="item.unit">{{ item.unit.name }}</span>
                                    </template>
                                    <template v-slot:item.actions="{item}">
                                        <v-btn small 
                                            dark 
                                            color="#424242"                                            
                                            class="float-right" 
                                            @click="handleSelectProduct(item)">
                                            <v-icon dark size="12" class="mr-2">
                                                fas fa-clipboard-check
                                            </v-icon>
                                            Seleccionar
                                        </v-btn>
                                    </template>                                    
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>

            <v-col cols="3" class="pt-0 pb-0">
                <v-container fluid class="pt-0 pb-0">
                    <v-row>
                        <v-col cols="12" class="pt-0 pb-0">
                            <v-card dark color="brown">
                                <v-card-title class="pt-2 pb-2">
                                    <span class="subtitle-2">Ingredientes</span>
                                    <v-spacer></v-spacer>
                                    <v-icon>
                                        fas fa-clipboard-list
                                    </v-icon>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="pt-1 pl-1 pr-1 pb-1 list-ingredients">
                                    <v-container>
                                        <v-row v-for="ingredient in ingredients" :key="ingredient.id">
                                            <v-col cols="12" class="pt-1 pb-1">
                                                <v-card>
                                                    <v-card-text class="pt-0 pb-0 pl-1 pr-1">
                                                        <v-list-item two-line dense class="pl-1 pr-1">
                                                            <v-list-item-avatar class="mr-2 mt-2 mb-2">
                                                                <v-img src="images/recipes/ingredient.png"></v-img>
                                                            </v-list-item-avatar>

                                                            <v-list-item-content>
                                                                <v-list-item-title>
                                                                    <span class="font-italic font-weight-bold">{{ ingredient.quantity }}</span>
                                                                    <span class="ml-1 font-italic font-weight-bold">{{ ingredient.subunit_abbr }}</span>
                                                                </v-list-item-title>
                                                                <v-list-item-subtitle>
                                                                    <span>{{ ingredient.supply_name }}</span>
                                                                </v-list-item-subtitle>
                                                            </v-list-item-content>

                                                            <v-list-item-action>
                                                                <v-btn icon color="red" @click="handleRemoveIngredient(ingredient)">
                                                                    <v-icon size="18">far fa-times-circle</v-icon>
                                                                </v-btn>
                                                            </v-list-item-action>

                                                        </v-list-item>                                            
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-btn block dark color="red">
                                Cancelar
                            </v-btn>
                        </v-col>
                        <v-col cols="6">                            
                            <v-btn block dark color="indigo" @click="handleStoreRecipe">
                                Guardar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
                
            </v-col>
        </v-row>

        <v-dialog
            v-model="dialog_supply"
            max-width="450"
        >
            <v-card v-if="supply_selected">
                <v-card-title class="headline pt-3 pb-3">
                    <span class="subtitle-2">Nuevo Ingrediente: {{ supply_selected.name}}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="4">
                                <v-text-field
                                    ref="quantity"
                                    v-model="formIngredient.quantity"
                                    label="Cantidad"
                                    dense
                                    outlined
                                    :rules="[
                                        () => !!formIngredient.quantity || 'Es necesario ingresar cantidad',
                                        () => (!!formIngredient.quantity && parseFloat(formIngredient.quantity) > 0) || 'Cantidad debe ser mayor a cero'
                                    ]"
                                    required
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="8">
                                <v-autocomplete
                                    ref="subunit_id"
                                    v-model="formIngredient.subunit_id"
                                    :items="subunits"
                                    :item-text="customText"
                                    clearable
                                    item-value="id"
                                    outlined
                                    dense
                                    label="Unidad de medida"
                                    :rules="[
                                        () => !!formIngredient.subunit_id || 'Es necesario seleccionar unidad de medida'
                                    ]"
                                    required
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="pt-0">
                                <v-switch
                                    v-model="formIngredient.discount_stock_supply"
                                    label="Control stock de insumo"
                                    dense
                                    hide-details
                                ></v-switch>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="red"
                        @click="handleCloseAddIngredient"
                        class="mr-2"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        dark
                        color="green"
                        @click="handleAddIngredient"
                        class="mr-2"
                    >
                        Agregar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import {mapState, mapActions} from 'vuex';

import Tools from '../../helpers/Tools';

export default {
    name: 'CreateRecipe',
    data () {
        return {
            category_value: null,
            supply_name: null,
            headers: [
                { text: 'NOMBRE', value: 'name' },
                { text: 'CATEGORIA', value: 'category_id' },
                { text: 'UND. MEDIDA', value: 'unit_id' },
                { text: 'STOCK', value: 'stock' },
                { text: '', value: 'actions', sortable: false }
            ],
            dialog_supply: false,
            supply_selected: null,
            formIngredient: {
                id: null,
                supply_id: null,
                supply_name: null,
                quantity: null,
                subunit_id: null,
                subunit_name: null,
                subunit_abbr: null,
                discount_stock_supply: false
            },
            name_recipe: null,
            ingredients: []
        }
    },
    computed: {
        ...mapState('categories', [
            'categories'
        ]),
        ...mapState('supplies', [
            'supplies'
        ]),
        ...mapState('subunits', [
            'subunits'
        ])
    },
    methods: {
        ...mapActions('categories', [
            'getAllCategories'
        ]),
        ...mapActions('supplies', [
            'getAllSupplies'
        ]),
        ...mapActions('subunits', [
            'getAllSubunits'
        ]),
        ...mapActions('recipes', [
            'store'
        ]),
        customText(item){
            let text = item.name
            
            return text
        },
        emptyRecipe() {
            this.name_recipe = null;
            this.ingredients = [];
        },
        handleSearchSupply() {
            let filters = {
                category_id: this.category_value,
                name: this.supply_name
            }
            this.getAllSupplies(filters);
        },
        handleSelectProduct(supply) {
            this.supply_selected = supply;
            this.setDataToFormIngredient(this.supply_selected);
            this.getSubunitsList(this.supply_selected.unit_id);
            this.dialog_supply = true;            
        },
        handleCloseAddIngredient() {
            this.emptyFormIngredient();
            this.supply_selected = null;
            this.closeDialog();
        },
        setDataToFormIngredient (data) {
            this.emptyFormIngredient();
            this.formIngredient.supply_id = data.id;
            this.formIngredient.supply_name = data.name;
        },
        emptyFormIngredient () {
            this.formIngredient.id = null;
            this.formIngredient.supply_id = null;
            this.formIngredient.supply_name = null;
            this.formIngredient.quantity = null;
            this.formIngredient.subunit_id = null;
            this.formIngredient.subunit_name = null;
            this.formIngredient.subunit_abbr = null;
            this.formIngredient.discount_stock_supply = false;
            this.clearErrors();
        },
        closeDialog() {
            this.dialog_supply = false;
        },
        async getSubunitsList(unit_id) {
            let filters = {
                unit_id: unit_id
            }
            await this.getAllSubunits(filters);
        },
        handleAddIngredient() {
            if (!this.existErrors()) {
                let today = new Date();
                this.formIngredient.id = today.getTime();
                let subunit_selected = Tools.getItemFromList(this.subunits, this.formIngredient.subunit_id);
                this.formIngredient.subunit_name = subunit_selected.name;
                this.formIngredient.subunit_abbr = subunit_selected.abbreviation;

                let item_ingredient = Object.assign({}, this.formIngredient);
                
                this.ingredients.push(item_ingredient);
                this.emptyFormIngredient();
                this.closeDialog();
            }            
        },
        handleRemoveIngredient(ingredient) {
            let index = Tools.findIndexFromItem(this.ingredients, ingredient.id);
            if (index > -1) {
                this.ingredients.splice(index, 1);
            }
        },
        handleStoreRecipe () {
            let recipe = {
                name: this.name_recipe,
                ingredients: this.ingredients
            }
            this.goToSaveRecipe(recipe);
        },
        async goToSaveRecipe(recipe){
            await this.store(recipe);
            this.emptyRecipe();
        },
        existErrors(){
            let hasErrors = false;

            Object.keys(this.formIngredient).forEach(f => {                
                if (this.$refs[f]) {
                    if (!this.formIngredient[f]) hasErrors = true
                    this.$refs[f].validate(true);
                }                
            });

            return hasErrors;
        },
        clearErrors() {
            Object.keys(this.formIngredient).forEach(f => {
                if (this.$refs[f]) this.$refs[f].reset()                
            });
        },
    },
    created () {
        this.getAllCategories();
    }
}
</script>

<style scoped>
.list-ingredients{
    height: 67vh !important;
    overflow-y: auto;
}
</style>